module.exports = __webpack_public_path__ + "img/andrew-jackson.4aa66cc9.png";